import RealTimeNav from './RealTimeNav';

export default RealTimeNav;
